(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/prescript.js'); 'use strict';

svs.sport = svs.sport || {};
svs.sport.best_rows = svs.sport.best_rows || {};
svs.sport.best_rows.views = svs.sport.best_rows.views || {};
svs.sport.best_rows.templates = svs.sport.best_rows.templates || {};
svs.sport.best_rows.models = svs.sport.best_rows.models || {};
svs.sport.best_rows.collections = svs.sport.best_rows.collections || {};

 })(window);